import { startCase } from "lodash";
import { FC, PropsWithChildren } from "react";

import {
  DrawerType,
  IDrawerContainerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { CommonDefaultDrawer } from "../common-default-drawer";
import { BaseDrawer } from "../drawer";
import { MobilFiltersFooter } from "./mobil-filters-footer";

export interface IMobileFiltersDrawerProps
  extends IDrawerContainerProps<DrawerType>, PropsWithChildren {
  title: string;
  onCloseDrawer: () => void;
}

export const MobileFiltersDrawer: FC<
  IMobileFiltersDrawerProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber, children, title }) => {
  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <CommonDefaultDrawer
        title={startCase(title)}
        onCloseDrawer={onCloseDrawer}
        Footer={<MobilFiltersFooter onCloseDrawer={onCloseDrawer} />}
      >
        {children}
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
